import { JSONSchema6 } from "json-schema";

const createRefundSchema: JSONSchema6 = {
    title: "CreateRefund",
    description: "Initiate a full or partial refund for a charge. At your discretion, you can also choose to overcompensate the buyer and refund more than the original Charge amount by either 15% or 75 USD/GBP/EUR or 8,400 YEN (whichever is less). The response for Create Refund will include a Refund ID. This is the only time this value will ever be returned. You must store the ID in order to retrieve Refund details at a later date.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-idempotency-key": {
                    title: "x-amz-pay-idempotency-key",
                    type: "string"
                },
                "x-amz-pay-simulation-code": {
                    title: "x-amz-pay-simulation-code",
                    type: "string"
                }
            },
            required: ["x-amz-pay-idempotency-key"]
        },
        "payload": {
            type: "object",
            properties: {
                "chargeId": {
                    type: "string"
                },
                "refundAmount": {
                    type: "object",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    },
                    required: ["amount", "currencyCode"]
                },
                "softDescriptor": {
                    type: "string"
                }
            },
        required: ["chargeId","refundAmount"]
        }
    },
    required: ["header", "payload"]
}

export default createRefundSchema
